<div class="container">
  <nav  aria-label="breadcrumb">
    <ol class="breadcrumb">

      <li *ngFor="let item of items; let i = index" class="breadcrumb-item btn" (click)="handleItemClick(item,i)">
        {{item}}
      </li>

    </ol>
  </nav>
</div>
